import { createApiService } from "@/core/api/apiService";
import type { ProfileDto } from "../types/profileTypes";

export const createProfileApiClient = () => {
  const client = createApiService("profiles");
  return {
    getMe: (signal?: AbortSignal): Promise<ProfileDto> =>
      client.get<ProfileDto>("/me", { signal }),
  };
};

export const profileApiService = createProfileApiClient();
